module.exports = __webpack_public_path__ + "static/media/ring.ab7e183d.svg";